module.exports = __webpack_public_path__ + "static/scale-model-of-the-palmer-family-residence-in-davenport-iowa-44b855368dd1d483a6fe71f954bb06bb.png";